/**
 * Strip HTML tags from a string and return plain text
 * @param {string} html - HTML string to strip
 * @returns {string} Plain text without HTML tags
 */
export function stripHtmlTags(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }
  
  // Create a temporary DOM element to parse HTML
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  
  // Return text content (automatically strips HTML tags)
  return tmp.textContent || tmp.innerText || '';
}

